import Vue from 'vue';
import moment from 'moment';
import draggable from 'vuedraggable';

import SvgView from '../components/SvgView.vue';
import BackView from '../components/BackView.vue';
import EditView from '../components/EditView.vue';
import HideView from '../components/HideView.vue';
import PinView from '../components/PinView.vue';
import InputView from '../components/InputView.vue';
import CheckboxView from '../components/CheckboxView.vue';
import TextareaView from '../components/TextareaView.vue';
import SaveView from '../components/SaveView.vue';
import MediumEditor from '../components/MediumEditor.vue';
import ImageUploadView from '../components/ImageUploadView.vue';
import VideoUploadView from '../components/VideoUploadView.vue';
import FileUploadView from '../components/FileUploadView.vue';
import RemoveView from '../components/RemoveView.vue';
import SortView from '../components/SortView.vue';
import PopupView from '../components/PopupView.vue';
import SelectView from '../components/SelectView.vue';
import DatePickerView from '../components/DatePickerView.vue';
import SavePanelView from '../components/SavePanelView.vue';
import ListEditView from '../components/ListEditView/ListEditView.vue';
import VisibleView from '../components/VisibleView.vue';
import ConfirmLeaveView from '../components/ConfirmLeaveView.vue';

import VueAppend from 'vue-append';
import { HandleDirective } from 'vue-slicksort';
import debounce from 'v-debounce';

const transliteration = require('transliteration');

let cid = 1;

Object.defineProperty(Array.prototype, 'last', {
    enumerable: false,
    configurable: false,
    writable: false,
    value: function () {
        return this[this.length - 1];
    }
});

function formatDate(value, format) {
    if (value) {
        return moment(String(value)).format(format || 'MMM DD YYYY');
    } else {
        return value;
    }
}

function back() {
    return this.$router.back();
}

function generateSlug(text) {
    const transliteratedText = transliteration.transliterate(text)
        .trim()
        .replace(/[^a-zA-Z0-9-]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '')
        .toLowerCase()
        .slice(0, 250);

    if (transliteratedText.length === 0) {
        return 'untitled';
    }

    return transliteratedText;
}

Vue.mixin({
    directives: { sort: HandleDirective, debounce },
    components: {
        HideView, SvgView, BackView, EditView, InputView, TextareaView, SaveView, MediumEditor,
        ImageUploadView, VideoUploadView, FileUploadView, RemoveView, SortView, PopupView, SelectView,
        DatePickerView, CheckboxView, PinView, draggable, SavePanelView, ListEditView,
        VisibleView, ConfirmLeaveView
    },
    data: function () {
        return {
            ...(app.settings || {})
        };
    },
    computed: {
        documentTitle() {
            return this.makeDocumentTitle();
        }
    },
    methods: {
        static(url) {
            return app.settings.staticUrl + url;
        },
        urlStatic(url) {
            return `url('${app.settings.staticUrl + url}'`;
        },
        generateCid() {
            return `cid${++cid}`;
        },
        reorder(list) {
            return list.map((item, index) => ({ ...item, order: index }));
        },
        customReorder(list, parentOrder) {
            // eslint-disable-next-line no-nested-ternary
            const newOrder = String(parentOrder).length === 1
                ? String(parentOrder) + '00'
                : String(parentOrder).length === 2 ? String(parentOrder) + '0' : String(parentOrder);

            return list.map((item, index) => ({ ...item, order: Number(newOrder) + index }));
        },
        reorderList(list, orderField) {
            return list.map((item, index) => ({ ...item, [orderField]: index }));
        },
        localReorder(list, name) {
            return list.map((item, index) => {
                // Создаем объект с новым значением specialistsOrder
                const specialistsOrder = { [name]: index };

                if (item.specialistsOrder && item.specialistsOrder.undefined) {
                    delete item.specialistsOrder.undefined;
                }

                // Проверяем, существует ли поле specialistsOrder в текущем элементе
                if (item.specialistsOrder) {
                    // Если существует, обновляем его значение, не затирая остальные
                    item.specialistsOrder[name] = index;
                } else {
                    // Если поле отсутствует, добавляем новое поле specialistsOrder
                    item.specialistsOrder = specialistsOrder;
                }

                // Возвращаем обновленный элемент списка
                return item;
            });
        },
        reorderObject(list) {
            return { ...this.reorder(Object.values(list)) };
        },
        formatDate,
        back,
        generateSlug
    }
});

Vue.filter('formatDate', formatDate);
Vue.filter('back', back);
Vue.filter('generateSlug', generateSlug);

Vue.use(VueAppend);

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his childrens
            if (!(el === event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
});
